import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings(response.data);
      } catch (error) {
        console.error("Error fetching settings:", error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-gray-50 border-t border-gray-200" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div>
            <Link to="/" className="logo-text text-3xl text-yellow-500 tracking-tighter">
              {settings?.nom_garage || "ACICAR"}
            </Link>
            <p className="mt-4 text-gray-600 text-sm leading-relaxed">
              {settings?.footer_description || "Votre garage de confiance à Crépy-en-Valois. Vente et réparation automobile depuis plus de 15 ans."}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Liens Rapides</h4>
            <ul className="space-y-3">
              <li><Link to="/voitures" className="text-gray-600 hover:text-yellow-600 transition-colors">Nos Voitures</Link></li>
              <li><Link to="/services" className="text-gray-600 hover:text-yellow-600 transition-colors">Nos Services</Link></li>
              <li><Link to="/galerie" className="text-gray-600 hover:text-yellow-600 transition-colors">Galerie</Link></li>
              <li><Link to="/contact" className="text-gray-600 hover:text-yellow-600 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-600">
                <MapPin className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
                <span>
                  {settings?.adresse || "1 rue de la Vallée"}<br />
                  {settings?.code_postal || "60000"} {settings?.ville || "Crépy-en-Valois"}
                </span>
              </li>
              <li className="flex items-center gap-3 text-gray-600">
                <Phone className="w-5 h-5 text-yellow-500" />
                <a href={`tel:${settings?.telephone?.replace(/\s/g, '') || "0770000000"}`} className="hover:text-yellow-600 transition-colors">
                  {settings?.telephone || "07 70 00 00 00"}
                </a>
              </li>
              <li className="flex items-center gap-3 text-gray-600">
                <Mail className="w-5 h-5 text-yellow-500" />
                <a href={`mailto:${settings?.email || "contact@acicar.fr"}`} className="hover:text-yellow-600 transition-colors">
                  {settings?.email || "contact@acicar.fr"}
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div>
            <h4 className="text-gray-900 font-semibold mb-4">Horaires</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-gray-600">
                <Clock className="w-5 h-5 text-yellow-500 flex-shrink-0 mt-0.5" />
                <div>
                  <p>{settings?.horaires_semaine || "Lun - Ven: 8h30 - 18h30"}</p>
                  <p>{settings?.horaires_samedi || "Samedi: 9h00 - 17h00"}</p>
                  <p>{settings?.horaires_dimanche || "Dimanche: Fermé"}</p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-gray-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            {settings?.footer_copyright || "© 2024 ACICAR. Tous droits réservés."}
          </p>
          <div className="flex gap-6">
            <Link to="/admin" className="text-gray-500 hover:text-yellow-600 text-sm transition-colors">
              Espace Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
